import './Proccess.scss'

export default function Proccess({
  value,
  color,
  backgroundColor,
  borderRadius,
  height,
}: {
  value: number;
  color: string;
  backgroundColor: string;
  borderRadius?: string;
  height?: string;
}) {
  return (
    <>
      <div className="RhvsFhqLwS" style={{ background: backgroundColor, borderRadius: borderRadius, height: height }}>
        <div className="rcDNTxwxpB" style={{ width: `${value}%`, borderRadius: borderRadius, height: height, background: color }}></div>
      </div>
    </>
  )
}